import { gql } from '@apollo/client';

export default gql`
  query userProfile {
    user {
      email
      name
      surname
      pushNotifications
      emailNotifications
      darkMode
      otpEnabled
      lastPasswordChangeAt
    }
  }
`;
